var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"disabled":_vm.disabled,"icon":_vm.icon,"label":_vm.label,"text":""},on:{"click":function($event){return _vm.open(_vm.item)}}})}
var staticRenderFns = []

export { render, staticRenderFns }